<template>
  <div class="app-content container center-layout mt-2">
      <div class="content-wrapper">
        <div class="content-body">
            <section class="card">
                <div id="invoice-template" class="card-body">
                     <div class="card-text">
                                        <img src="assets/images/banner.jpg" alt="banner" style="width:100%">
                                    </div><br>
                        <div id="invoice-company-details" class="row">
                            <div class="col-md-6 col-sm-12 text-center text-md-left">
                                <div class="media">
                                    <img src="assets/images/icon.png" alt="company logo" style="max-height:80px">
                                    <div class="media-body">
                                        <ul class="ml-2 px-0 list-unstyled">
                                            <li class="text-bold-800">UNIVERSITY OF GHANA</li>
                                            <li>ALUMNI RELATION OFFICE</li>
                                            <li><a href="mailto:alumnirelations@ug.edu.gh">alumnirelations@ug.edu.gh</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12 text-center text-md-right">
                                <h2>INVOICE</h2>
                                <p class="pb-3"></p>
                            </div>
                        </div>
                    

                        <div id="invoice-customer-details" class="row pt-2">
                            <div class="col-sm-12 text-center text-md-left">
                                <p class="text-muted">Bill To</p>
                            </div>
                            <div class="col-md-6 col-sm-12 text-center text-md-left">
                                <ul class="px-0 list-unstyled">
                                    <li class="text-bold-800">{{formdata.title}}. {{formdata.surname}} {{formdata.firstname}} {{formdata.othernames}}</li>
                                    <li>{{formdata.email}}</li>
                                    <li>{{formdata.phone}}</li>
                                </ul>
                            </div>
                            <!-- <div class="col-md-6 col-sm-12 text-center text-md-right">
                                <p><span class="text-muted">Invoice Date :</span> 06/05/2016</p>
                            </div> -->
                        </div>

                                <div id="invoice-items-details" class="pt-2">
                                    <div class="row">
                                        <div class="table-responsive col-sm-12">
                                            <table class="table table-borderless">
                                            <thead class="bg-info">
                                                <tr>
                                                <th>#</th>
                                                <th>Ticket</th>
                                                <th class="text-right">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                <th scope="row">1</th>
                                                <td>{{pickTicketParts(formdata.ticket,formdata.daypasstype).name}} ( {{pickTicketParts(formdata.ticket,formdata.daypasstype).desc}} )</td>
                                                <td class="text-right">GHS {{calculateAmount(formdata.ticket,formdata.daypasstype)}}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-7 col-sm-12 text-center text-md-left">
                                            <p class="lead"></p>					
                                        </div>
                                        <div class="col-md-5 col-sm-12">
                                            <p class="lead">Total due</p>
                                            <div class="table-responsive">
                                                <table class="table">
                                                <tbody>
                                                    <tr>
                                                        <td>Sub Total</td>
                                                        <td class="text-right">GHS {{calculateAmount(formdata.ticket,formdata.daypasstype)}}</td>
                                                    </tr>
                                                </tbody>
                                                </table>
                                            </div>
                                            <br>
                                             <p class="lead">Choose Payment Mode</p>
                                             <div class="row" style="border:1px dashed #ddd;padding:10px">
                                                 <div class="col-sm-12">
                                                  <fieldset v-for="(i,index) in paymentoptions" :key="index">
                                                        <label class="custom-control custom-radio">
                                                        <input name="ticket" type="radio" class="custom-control-input" :value="index" v-model="payments">
                                                        <span class="custom-control-indicator"></span>
                                                        <span class="custom-control-description">{{i.name}}</span>
                                                        </label>
                                                        
                                                    </fieldset>
                                                    </div>
                                             </div>
                                        </div>
                                    </div>

                                


                                </div>

                
                                <div id="invoice-footer">
                                    <div class="row">
                                        <div class="col-md-7 col-sm-12">
                                            
                                        </div>
                                        <div class="col-md-5 col-sm-12 text-center">
                                             <button type="button" @click="previous" class="btn btn-info btn-lg my-1 box-shadow-1"><i class="fa fa-angle-left"></i> Previous</button>&nbsp;
                                            <button type="button" @click="saveAndPay" :disabled="toggledisabled" class="btn btn-success my-1 btn-lg box-shadow-1"><i class="fa fa-paper-plane-o"></i> Continue <img v-show="toggledisabled" src="assets/images/loading.gif" style="max-height: 20px"></button>
                                        </div>
                                    </div>
                                </div>
                

                </div>
            </section>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Invoice',
  props:{
      toggledisabled:{
          type:Boolean,
          default:false
      },
      formdata:{
          type:Object,
        //   default:{
        //       title:'',
        //       surname:'',
        //       othernames:'',
        //       firstname:'',
        //       email:'',
        //       phone:'',
        //       degree:'',
        //       daypasstype:[],
        //       ticket:'',
        //       yearofgraduation:'',
        //       hall:''
        //   }
      }
  },
  data() {
      return {
           ticketstype:[
               {label:'FAMILY RATE - GHS 1400.00',name:'FAMILY RATE',value:1400},
              {label:'V.I.P - GHS 750.00',name:'V.I.P',value:750},
              {label:'EXECUTIVE - GHS 450.00',name:'EXECUTIVE',value:450},
              {label:'STANDARD - GHS 350.00',name:'STANDARD',value:350},
              {label:'DAY PASS - GHS 70.00',name:'DAY PASS',value:70}
          ],

          paymentoptions:[
              {name:'Pay With ExpressPay',value:1, send:'Pay With ExpressPay'},
              {name:'Pay With Ego Ticket - (debit/credit card/paypal etc)',value:2, send:'Pay With Ego Ticket'},
              {name:'Pay Ticket With Short Code',value:3,send:'Pay Ticket With Short Code'},
              {name:'Buy Ticket By Calling Us',value:4,send:'Buy Ticket By Calling Us'},
          ],

          payments:'',
      }
  },
  methods: {
       pickDescription:function(tickettype,daypasstype=null){
          let desc = '';
          switch (tickettype) {
              case 'FAMILY RATE':
                  desc = 'FAMILY RATE rooms are double occupancy(for adults) plus 3 in a room(for 3 children under 15).';
              break;
              case 'V.I.P':
                  desc = 'V.I.P rooms are single occupancy en-suite.';
              break;
             case 'EXECUTIVE':
                  desc = 'Executive rooms are single occupancy with shared facility.';
             break;
             case 'STANDARD':
                  desc = 'Standard rooms are two occupants in a room with shared facility.';
             break;
             case 'B. PACK':
                  desc = 'B. PACK rooms are four occupants in a room with shared facility.';
             break;
              case 'DAY PASS':
                  desc = daypasstype==null ? '' : daypasstype;
             break;
              default:
            
                  break;
          }
          return desc;
        },
      previous(){
          this.$emit('previous',true);
      },
      calculateAmount(ticket,daypasstype){
            let amount = ticket.split('::')[1];
          if(daypasstype.length  > 0 && ticket.indexOf('DAY PASS') !== -1){
              return amount * daypasstype.length;
          }
          return amount;
      },
      pickTicketParts(ticket,daypasstype=null){
          if(ticket && ticket !==''){
               let parts = ticket.split('::');
               let name = parts[0];
               let desc = this.itseconfig.pickDescription(parts[0]);
               if(daypasstype && daypasstype.length > 0 && daypasstype instanceof Array){
                   desc = daypasstype.join(',');
               }
               return {name:name,desc:desc};
          }else{
              return {name:'',value:'',desc:''};
          }
        
      },
      saveAndPay(){
          if(this.payments===''){
              this.$swal('Alert','Please Choose a Payment Method','info');
              return;
          }
          this.$emit('saveandpay',this.paymentoptions[this.payments]);
      }
  },
  
  
}
</script>
<style scoped>

</style>
